<template>
  <article class="resources_item" :id="resource.id">
    <div class="resources_item-source mb-2">
      <a
        v-on:click="trackResourceAccessed(resource, {
          trigger: 'domain url link',
          source: source,
          ranking: ranking
        })"
        class="main-link"
        :href="resource.url"
        target="_blank"
      >
        {{ resource.url | extractDomain }}
      </a>
    </div>
    <div class="resources_item-heading">
      <h2 class="mt-0 mb-2 resources_item-title">
        <a
          v-on:click="trackResourceAccessed(resource, {
            trigger: 'main link',
            source: source,
            ranking: ranking
          })"
          class="main-link"
          :href="resource.url"
          target="_blank"
        >
          {{ resource.name }}
        </a>
      </h2>
    </div>
    <div class="resources_item-description mb-2">
        <router-link
          :to="resourceLink"
        >
          <p>
            {{ resource.description }}
          </p>
          <p class="resources_item-description-more">
              <span class="read-more">Read more</span>
          </p>
        </router-link>
    </div>
    <div class="resources_item-topic">
      <TopicLabel
        v-for="(tag, index) in resource.tags"
        :key="index"
        :tag="tag"
      />
    </div>
  </article>
</template>

<script>
import TopicLabel from './TopicLabel'
import { trackResourceAccessed } from '@/utils/analytics/main'

export default {
  name: 'ResourcePreview',
  components: { TopicLabel },
  props: {
    resource: {
      required: true,
      type: Object
    },
    ranking: {
      required: true,
      type: Number
    },
    source: {
      required: true,
      type: String
    }
  },
  computed: {
    resourceLink () {
      return {
        name: 'single-resource',
        params: {
          slug: this.resource.slug
        }
      }
    }
  },
  filters: {
    short: (text) => {
      return text.substr(0, 120) + '...'
    }
  },
  methods: {
    trackResourceAccessed
  }
}
</script>
